import { apiServer, apiServer_v2 } from "../config/config";
import { Storage } from "../../common/storage";

// Single-flight: when many authed requests hit 401 in the same tick, share
// one /user/refresh-token instead of firing N parallel refreshes.
let refreshInFlight: Promise<Response> | null = null;

// Function to refresh the access token
export async function refreshAccessToken(
  refreshToken: string,
): Promise<Response> {
  if (!refreshInFlight) {
    refreshInFlight = (async () => {
      const formData = new FormData();
      formData.append("refresh_token", refreshToken);
      return fetch(apiServer + "/user/refresh-token", {
        method: "POST",
        body: formData,
      });
    })();
    refreshInFlight.finally(() => {
      refreshInFlight = null;
    });
  }
  // Each caller gets its own clone so .json()/.ok reads don't race on the
  // shared body stream.
  const shared = await refreshInFlight;
  return shared.clone();
}

// Function to handle fetching with token refresh logic
export async function fetchWithToken(
  url: string | URL | Request,
  options = {}
) {
  // console.log("fetchWithToken url", url);
  // console.log("fetchWithToken options", options);

  const userString = Storage.getString("currentUser");
  const user = userString ? JSON.parse(userString) : null;
  if (!user) return null;

  let accessToken = user.accessToken;
  const refreshToken = user.refreshToken;

  try {
    // Make the API request
    const response = await fetch(url, options);

    // Clone the response to read its body without disturbing the original stream
    let responseClone = response.clone();
    let data;
    try {
      data = await responseClone.json();
    } catch (error) {
      console.log("Offending response:", responseClone);
      throw new Error(`Uknown error: ${responseClone.status}`);
    }

    // Check if the response indicates an expired token
    if (
      data.status === "error" &&
      data.message === "Please perform the login"
    ) {
      // Token is expired, attempt to refresh it
      const refreshResponse = await refreshAccessToken(refreshToken);

      console.log("refreshResponse.ok", refreshResponse.ok);
      console.log("refreshResponse", refreshResponse);

      if (refreshResponse.ok) {
        const refreshData = await refreshResponse.json();

        //console.log("fetchWithToken refreshData", refreshData);

        // Update tokens in local storage
        accessToken = refreshData.access_token;
        user.accessToken = accessToken;

        if (refreshData.refresh_token) {
          user.refreshToken = refreshData.refresh_token;
        }

        console.log("fetchWithToken updated user", user);

        Storage.setCurrentUser(JSON.stringify(user));

        // Retry the original request with the new access token
        (options as any).headers["Authorization"] = `Bearer ${accessToken}`;

        //console.log("fetchWithToken updated options", options);

        const retryResponse = await fetch(url, options);
        // return retryResponse.json();
        return retryResponse;
      } else {
        // Refresh failed — clear the dead session so subsequent authed
        // calls don't keep looping refresh attempts with the same bad token.
        Storage.clearCurrentUser();
        throw new Error("Failed to refresh token. Please perform the login!");
      }
    }

    // Return the original response if no token issue
    return response;
  } catch (error) {
    console.error("API Error fetchWithToken:", error, url);
    throw error;
  }
}
